import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import type { MagentoShippingMethod } from "@jti/magento-types";

type OnePageCheckoutForm = {
  selectedShippingMethod: MagentoShippingMethod | null;
};

export const initialOnePageCheckoutFormFormState: OnePageCheckoutForm = {
  selectedShippingMethod: null,
};

export const onePageCheckoutFormSlice = createSlice({
  name: "onePageCheckoutForm",
  initialState: initialOnePageCheckoutFormFormState,

  reducers: {
    setSelectedShippingMethod(state, action: PayloadAction<MagentoShippingMethod>) {
      state.selectedShippingMethod = action.payload;
    },
  },
});

export const { setSelectedShippingMethod } = onePageCheckoutFormSlice.actions;
